import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';
import { InvoiceDeliveryMethod, PaymentNoticeDeliveryStatus, ReminderDeliveryMethod } from './const/enum';
import { AmortizationPlanStatus, AmortizationPlanStatusToString } from './const/enum';

export class AmortizationPlanInstallment {
  id: string;
  invoiceRowId?: string;
  paymentNoticeRowId?: string;
  dueDate: LocalDate;
  amount: Money;
  notice: string;
  paidAmount: Money;
  creditedAmount: Money;
  customerLossAmount: Money;
}

export class AmortizationPlanDocument {
  id: string;
  documentId: string;
  caption: string;
  document: File;
  size: number;
  uploadedDate: Date;
  fileName: string;
  fileSizeInBytes: number;
  sortOrder: number;
  amortizationPlan: string;

  toJSON() {
    return {
      caption: this.caption,
      amortizationPlan: this.amortizationPlan,
    };
  }
}

export class AmortizationPlanInvoice {
  invoiceId: string;
  invoiceNumber: string;
  dueDate: LocalDate;
  remainingAmount: Money;
}

export class AmortizationPlanPaymentNotice {
  id: string;
  ocrNumber: string;
  dueDate: LocalDate;
  amount: Money;
  remainingAmount: Money;
  createdDate: Date;
  sentDate: Date;
  sequenceNumber?: number | null;
  deliveryMethod: ReminderDeliveryMethod;
  deliveryAddress: string;
  latestDelivery: AmortizationPlanPaymentNoticeDelivery;
  deliveries: AmortizationPlanPaymentNoticeDelivery[];
}

export class AmortizationPlanPaymentNoticeDelivery {
  id: string;
  method: ReminderDeliveryMethod;
  status: PaymentNoticeDeliveryStatus;
  createdDate: Date;
  lastAttemptedAt?: Date;
  sentDate?: Date;
  attemptCount: number;
  deliveryAddress: string;
  errorMessage: string;
  provider: string;
  providerReference: string;
  emailDeliveryStatusText: string;
}

export interface AmortizationPlanInterestInvoiceAddress {
  name: string;
  additionalName: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  countryCode?: string;
}

export interface AmortizationPlanInterestInvoiceDelivery {
  deliveryMethod: InvoiceDeliveryMethod | null;
  email: string | null;
  eInvoiceAddress: string | null;
  address: AmortizationPlanInterestInvoiceAddress;
}

export class AmortizationPlan extends ModelBase {
  number: number;
  debtorContactId: string;
  debtorContactName: string;
  articleId: string;
  articleCaption: string;
  companyId?: string;
  companyName: string;
  leaseAgreementId?: string;
  leaseAgreementNumber: string;
  leaseAgreementDisplayName: string;
  separateInvoicing: boolean;
  interestRate: number;
  totalAmount: Money;
  calculatedInterestAmount: Money;
  interestInvoiceId?: string;
  interestInvoiceNumber: string;
  interestInvoiceAmount?: Money;
  interestInvoiceDueDate?: LocalDate;
  interestInvoiceDelivery: AmortizationPlanInterestInvoiceDelivery;
  paymentNoticeDeliveryMethod?: InvoiceDeliveryMethod;
  status: AmortizationPlanStatus;
  canApprove: boolean;
  canWithdrawApproval: boolean;
  canCancel: boolean;
  canSendInvoicesToDebtCollection: boolean;
  createdAt: Date;
  note: string;
  eSignatureErrandId?: string;
  isESignatureCompleted: boolean;
  invoices: AmortizationPlanInvoice[];
  paymentNotices: AmortizationPlanPaymentNotice[];
  installments: AmortizationPlanInstallment[];
  documents: AmortizationPlanDocument[];

  get statusCaption(): string {
    return AmortizationPlanStatusToString(this.status);
  }
}
